import { useTranslation } from 'react-i18next';
import { useErrorText } from '@/lib/error-text';
import { ApiError } from '@/resources/http';

export function usePushErrorText(): (error: unknown) => string {
  const { t } = useTranslation();
  const errorText = useErrorText();

  return (error: unknown) => {
    if (error instanceof ApiError) return errorText(error);

    const reason = error instanceof Error ? `${error.name}: ${error.message}` : String(error);
    return t('push.browserFailed', { reason });
  };
}
